import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoginLayout, { ActionButton, Input } from "../../components/loginLayout";
import { graphqlRequest } from "../../services/apiService";
import { useAppContext } from "../../context/appContext";

const AdminRegister = () => {
  const { setPopupMessage } = useAppContext();
  const [searchParams] = useSearchParams();
  const roleBySearchParams = searchParams.get("role");
  const navigate = useNavigate();

  useEffect(() => {
    if (!roleBySearchParams) {
      navigate("/role");
    }
  }, [roleBySearchParams]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    role: roleBySearchParams,
    company: "",
    city: "",
    state: "",
    zipCode: "",
    streetAddress: "",
    address: "",
    password: "",
    cpassword: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.cpassword) {
      setError("Passwords do not match");
      setPopupMessage("Passwords do not match");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const query = `mutation RegisterUser($firstName: String, $lastName: String, $email: String, $password: String, $role: String, $phone: String, $company: String, $city: String, $state: String, $zipCode: String, $streetAddress: String, $address: String) { 
        registerUser(firstName: $firstName, lastName: $lastName, email: $email, password: $password, role: $role, phone: $phone, company: $company, city: $city, state: $state, zipCode: $zipCode, streetAddress: $streetAddress, address: $address) { 
          id 
          firstName 
          lastName 
          email 
          phone 
          role 
          company 
          city 
          state 
          zipCode 
          status 
          streetAddress 
          address 
        }
      }`;

      const variables = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        password: formData.password,
        role: roleBySearchParams,
        phone: formData.phone,
        company: formData.company,
        city: formData.city,
        state: formData.state,
        zipCode: formData.zipCode,
        streetAddress: formData.streetAddress,
        address: formData.streetAddress,
      };

      const data = await graphqlRequest(query, variables);
      if (data.registerUser) {
        setPopupMessage("Registration successful!");
        setTimeout(() => navigate("/"), 2000);
      }
    } catch (err) {
      setPopupMessage(
        err.message || "Registration failed"
      );
    } finally {
      setLoading(false);
    }
  };

  function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  return (
    // <LoginLayout
    //   error={error}
    //   loading={loading}
    //   onSubmit={handleSubmit}
    //   registerTitle={`${capitalizeFirstLetter(
    //     roleBySearchParams
    //   )} Registration`}
    //   actionText="Register"
    //   links={{ login: "/" }}
    // >
    //   <div className="space-y-2">
    //     <div className="flex flex-col md:flex-row gap-2">
    //       <Input
    //         name="firstName"
    //         placeholder="First Name"
    //         value={formData.firstName}
    //         onChange={handleChange}
    //         required
    //       />
    //       <Input
    //         name="lastName"
    //         placeholder="Last Name"
    //         value={formData.lastName}
    //         onChange={handleChange}
    //         required
    //       />
    //     </div>
    //     <Input
    //       type="email"
    //       name="email"
    //       placeholder="Email"
    //       value={formData.email}
    //       onChange={handleChange}
    //       required
    //     />
    //     <Input
    //       type="tel"
    //       name="phone"
    //       placeholder="Phone Number"
    //       value={formData.phone}
    //       onChange={handleChange}
    //       required
    //     />
    //     {roleBySearchParams === "client" && (
    //       <Input
    //         name="company"
    //         placeholder="Company Name"
    //         value={formData.company}
    //         onChange={handleChange}
    //         required
    //       />
    //     )}
    //     <Input
    //       name="streetAddress"
    //       placeholder="Street Address"
    //       value={formData.streetAddress}
    //       onChange={handleChange}
    //       required
    //     />
    //     {/* <Input
    //       name="address"
    //       placeholder="Additional Address"
    //       value={formData.address}
    //       onChange={handleChange}
    //     /> */}
    //     <div className="flex flex-col md:flex-row gap-2">
    //       <Input
    //         name="city"
    //         placeholder="City"
    //         value={formData.city}
    //         onChange={handleChange}
    //         required
    //       />
    //       <Input
    //         name="state"
    //         placeholder="State"
    //         value={formData.state}
    //         onChange={handleChange}
    //         required
    //       />
    //       <Input
    //         name="zipCode"
    //         placeholder="Zip Code"
    //         value={formData.zipCode}
    //         onChange={handleChange}
    //         required
    //       />
    //     </div>
    //     <div className="flex flex-col md:flex-row gap-2">
    //       <Input
    //         type="password"
    //         name="password"
    //         placeholder="Password"
    //         value={formData.password}
    //         onChange={handleChange}
    //         required
    //       />
    //       <Input
    //         type="password"
    //         name="cpassword"
    //         placeholder="Confirm Password"
    //         value={formData.cpassword}
    //         onChange={handleChange}
    //         required
    //       />
    //     </div>
    //   </div>
    // </LoginLayout>
    <LoginLayout
    // error={error}
    // loading={loading}
    // onSubmit={handleSubmit}
    title={`Registration`}
    // actionText="Register"
    links={{ login: "/" }}
  >
    <div className={`h-full flex flex-col justify-center `}>
      {/* <div className="text-2xl md:text-3xl text-white text-center">
        {`${capitalizeFirstLetter(roleBySearchParams)} Registration`}
      </div> */}

      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md pt-5 space-y-4"
      >
        <div className="space-y-2">
          <div className="flex flex-col md:flex-row gap-2">
            <Input
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              label="First Name"
              onChange={handleChange}
              required
            />
            <Input
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              label="Last Name"
              onChange={handleChange}
              required
            />
          </div>
          <Input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            label="Email"
            onChange={handleChange}
            required
          />
          <Input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            label="Phone Number"
            onChange={handleChange}
            required
          />
          {roleBySearchParams === "client" && (
            <Input
              name="company"
              placeholder="Company Name"
              value={formData.company}
              label="Company Name"
              onChange={handleChange}
              required
            />
          )}
          <Input
            name="streetAddress"
            placeholder="Street Address"
            value={formData.streetAddress}
            label="Street Address"
            onChange={handleChange}
            required
          />
          {/* <Input
            name="address"
            placeholder="Additional Address"
            value={formData.address}
            onChange={handleChange}
          /> */}
          <div className="flex flex-col md:flex-row gap-2">
            <Input
              name="city"
              placeholder="City"
              value={formData.city}
              label="City"
              onChange={handleChange}
              required
            />
            <Input
              name="state"
              placeholder="State"
              value={formData.state}
              label="State"
              onChange={handleChange}
              required
            />
            <Input
              name="zipCode"
              placeholder="Zip Code"
              value={formData.zipCode}
              label="Zip Code"
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col w-full md:flex-row gap-2">
            <Input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              label="Password"
              onChange={handleChange}
              required
            />
            <Input
              type="password"
              name="cpassword"
              placeholder="Confirm Password"
              value={formData.cpassword}
              label="Confirm Password"
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <ActionButton
          loading={loading}
          actionText={"Register"}
          className="hidden md:block"
        />
      </form>
    </div>
  </LoginLayout>
  );
};

export default AdminRegister;
